import {formErrors} from "./errors";

export const formInputs = ($r, $formGroups, {getInputEntries} = {}) => {
    const getInputEntriesContext = {
        findInputEntries: $formGroups => Object.entries($formGroups)
            .map(([key, $input]) => ([key, $input.find('input, textarea, select').get(0)])),
        date: (key, $formGroups, inputEntries) => {
            const $inputs = $formGroups[key].find('input');
            const index = inputEntries.findIndex(([entryKey]) => key === entryKey);
            inputEntries[index] = [key, {
                day: $inputs.get(0),
                month: $inputs.get(1),
                year: $inputs.get(2),
            }];
            return inputEntries;
        },
        radio: (key, $formGroups, inputEntries) => {
            const $inputs = $formGroups[key].find('input');
            const index = inputEntries.findIndex(([entryKey]) => key === entryKey);

            // Weird cash behavior on map
            inputEntries[index] = [key, []];
            for (let n = 0; n < $inputs.length; ++n)
                inputEntries[index][1].push($inputs.get(n));
            return inputEntries;
        },
        select: (key, $formGroups, inputEntries) => {
            const $input = $formGroups[key].find('select');
            const value = $input.attr('data-value');
            $input.find(`option[value="${value}"]`).attr('selected', 'selected');
            return inputEntries;
        },
        custom: (key, $formGroups, inputEntries) => {
            const index = inputEntries.findIndex(([entryKey]) => key === entryKey);
            inputEntries[index] = [key, null];
            return inputEntries;
        },
    };

    if (!getInputEntries)
        getInputEntries = ({findInputEntries}) => findInputEntries($formGroups);

    const inputEntries = getInputEntries(getInputEntriesContext);
    const inputs = Object.fromEntries(inputEntries);
    console.log(inputEntries)

    return {
        inputEntries,
        inputs,
        ...formErrors($r, $formGroups),
    };
};
